module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Rose Gold + Lavender Open.2f0d8858.png";